import { CruiseSearchWidget } from 'components/CruiseSearchWidget/CruiseSearchWidget';
import { CruiseSearchWidgetProps } from 'components/CruiseSearchWidget/types';
import { FiltersModalProvider } from 'components/FiltersModalProvider/FiltersModalProvider';

function Wrapper(props: CruiseSearchWidgetProps) {
	return (
		<FiltersModalProvider>
			<CruiseSearchWidget {...props} />
		</FiltersModalProvider>
	);
}

export default Wrapper;
